import { type DisqualificationReason } from "@/constants";

import { useTrackEvent } from "./useTrackEvent";

/** Product name used in disqualification analytics events. */
const CMS_ACCESS_PRODUCT = "CMS_ACCESS";
const DISQUALIFICATION_REASON: DisqualificationReason =
  "HEALTH_CONDITIONS_CRITERIA_NOT_MET";

/**
 * Returns a function that tracks that a member is not eligible for ACCESS. The
 * health answers are PHI, so they are never sent in analytics events. Only the
 * fact of disqualification is tracked.
 */
export const useTrackAccessDisqualified = () => {
  const { trackAnonEvent, trackIdentifiedEvent, trackSensitiveEvent } =
    useTrackEvent();

  return () => {
    trackAnonEvent("b2bEnrollmentAnonUserDisqualified", {
      product: CMS_ACCESS_PRODUCT,
      disqualificationReason: DISQUALIFICATION_REASON,
    });
    trackIdentifiedEvent("b2bEnrollmentIdentifiedUserDisqualified", {
      product: CMS_ACCESS_PRODUCT,
    });
    trackSensitiveEvent("b2bEnrollmentSensitiveUserDisqualified", {
      product: CMS_ACCESS_PRODUCT,
      disqualificationReason: DISQUALIFICATION_REASON,
    });
  };
};
